import {Component, Input, OnDestroy, OnInit, ViewEncapsulation} from '@angular/core';
import {FormArray, FormControl, FormGroup, FormGroupDirective, ValidatorFn, Validators} from '@angular/forms';
import {Event} from '@angular/router';
import {IDocumentTypesDto} from 'app/main/pages/documents/dto/document-listing.dto';
import {ICategory} from 'app/main/shared/shared/table/components/category-name/category-name.component';
import {BehaviorSubject, Subject} from 'rxjs';
import {take} from 'rxjs/operators';
import {FileSizePipe} from '../../../../../../../pipes/file-size.pipe';
import {FilesValidatorsService} from '../../../../../../shared/validators/files-validators';
import {CategoryService} from '../../../../../category.service';
import {DocumentTypeService} from '../../../../../settings/documenttype/document-type.service';


//TODO: to refactor since this component is not scoped to a bulk upload modal any more it should be moved and maybe renamed 

@Component({
    selector: 'app-upload-files',
    templateUrl: './upload-files.component-step.component.html',
    styleUrls: ['./upload-files.component-step.component.scss'],
    encapsulation: ViewEncapsulation.None,
    providers:[FileSizePipe]
})
export class UploadFilesComponentStepComponent<P extends {document_type_id:number, category_ids:number[]}> implements OnInit,  OnDestroy {
    private untilDestroy$: Subject<void> = new Subject<void>();

    @Input() formArrayName: string ='files'
    @Input() acceptableFiles: string[] = ["application/pdf"];
    @Input() maxFileSize: number = 20 * 1024 * 1024;
    @Input() uploadRequestParams: P;
    @Input() section: string = 'document';

    documentTypes$: BehaviorSubject<IDocumentTypesDto[]> = new BehaviorSubject<IDocumentTypesDto[]>([]);
    categories$: BehaviorSubject<ICategory[]> = new BehaviorSubject<ICategory[]>([]);
    form: FormGroup;
    get formFiles (){
       return this.form.controls[this.formArrayName] as FormArray;
    }

    set formFiles(formFiles : FormArray) {
        this.form.controls[this.formArrayName] = formFiles;
    }

    filesValidation: ValidatorFn[];

    constructor(
                private hostFrom: FormGroupDirective,
                private categoryService: CategoryService,
                private documentTypeService: DocumentTypeService,
                private filesValidatorsService:FilesValidatorsService
            ) {
    }

    ngOnInit(): void {
        this.filesValidation =[
            this.filesValidatorsService.maxFileSizeValidator(this.maxFileSize),
            this.filesValidatorsService.fileTypeValidator(this.acceptableFiles)
        ];
        this.form = this.hostFrom.form;
        this.fetchCategories();
        this.fetchDocumentTypes();

    }

    ngOnDestroy(): void {
        this.untilDestroy$.next();
        this.untilDestroy$.complete();
    }

    onFileDelete(index: number) {
        if (index > -1) {
            this.formFiles.removeAt(index);
        }
    }

    onFileDropped($event: FileList | Event) {
        let tempFilesList:File[] = [];

        if ($event instanceof Event) {
            tempFilesList = [
                ...(($event.target as HTMLInputElement).files) as unknown as File[]
            ];
        } else {
            tempFilesList = $event as unknown as File[];
        }
        for (let i = 0; i < tempFilesList.length; i++) {
            if (!this.hasAlreadyAdded(tempFilesList[i])) {
                this.formFiles.push( new FormGroup({
                    progress: new FormControl(0),
                    file: new FormControl(tempFilesList[i], this.filesValidation),
                    category_ids:new FormControl([]),
                    document_type_id:new FormControl(null,  [Validators.required]),
                }));
            }
        }
    }


    private hasAlreadyAdded(file: File): boolean {
        return this.formFiles?.value.some(x => this.compareFile(file, x.file));
    }

    private compareFile(fileA: File, fileB: File): boolean {
        return fileA.name === fileB.name && fileA.type === fileB.type && fileA.size === fileB.size;
    }
    
    private fetchCategories() {
        this.categoryService.fetchCategories('all')
            .pipe(take(1))
            .subscribe(x=> this.categories$.next(x as ICategory[]));
    }

    private fetchDocumentTypes() {
        this.documentTypeService.getDocumentTypes(1, '', 'all')
            .pipe(take(1))
            .subscribe(x=>this.documentTypes$.next(x as  IDocumentTypesDto[]));
    }
}
